import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IConfigurableOptionWarning, TConfigurableOptionWarning } from './configurable-option-warning.service';

@Component({
    selector: 'configurable-option-warning',
    templateUrl: './configurable-option-warning.html',
    standalone: true,
    imports: [NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigurableOptionWarningComponent {
    warningId = TConfigurableOptionWarning;
    constructor(
        @Inject(MODAL_DATA)
        public warning: IConfigurableOptionWarning
    ) {}
}
